/** Navigates the page away. jsdom can't observe a location change, so tests mock this module. */
export const navigateTo = (url: string): void => {
  window.location.href = url;
};
